import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { init } from './modules'
import { languageChange } from 'store/siteConfig'
import Loading from 'components/Loading'

export default function(route) {
  const Merchants = Loadable({
    loader: () => import('./Merchants'),
    render(loaded, props) {
      const Component = connect(
        (state) => ({
          mapsMerchantsState: state.mapsMerchantsState,
          siteConfig: state.siteConfig,
        }),
        {
          init,
          languageChange,
        }
      )(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path={`${route.match.path}/merchants`}
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <Merchants {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
